import { Document, Font, Page } from '@react-pdf/renderer';
import { FC } from 'react';
import { IntlFormatters } from '@formatjs/intl/src/types';

import { ResumePdfCompanyExperience } from './ResumePdfCompanyExperinece';
import { ResumePdfContacts } from './ResumePdfContacts';
import { ResumePdfCourses } from './ResumePdfCourses';
import { ResumePdfEducation } from './ResumePdfEducation';
import { ResumePdfGeneralInfo } from './ResumePdfGeneralInfo';
import { ResumePdfHeader } from './ResumePdfHeader';
import { ResumePdfLanguages } from './ResumePdfLanguages';
import { ResumePdfSkills } from './ResumePdfSkills';
import { styles } from './styles';

const fontsOrigin = process.env.NODE_ENV === 'development' ? 'http://127.0.0.1:9994' : '';

Font.register({
  family: 'Roboto',
  fonts: [
    { src: `${fontsOrigin}/static/fonts/roboto-regular.woff` },
    { src: `${fontsOrigin}/static/fonts/roboto-bold.woff`, fontWeight: 'bold' },
  ],
});

Font.register({
  family: 'FontAwesome',
  fonts: [
    { src: `${fontsOrigin}/static/fonts/fa-solid-900.woff2`, fontWeight: 900 },
    { src: `${fontsOrigin}/static/fonts/fa-regular-400.woff2`, fontWeight: 400 },
  ],
});

Font.register({
  family: 'FontAwesomeBrands',
  fonts: [{ src: `${fontsOrigin}/static/fonts/fa-brands-400.woff2`, fontWeight: 400 }],
});

type ResumePdfProps = {
  formatDate: IntlFormatters['formatDate'];
  formatMessage: IntlFormatters['formatMessage'];
  profile: AH$Profile;
};

export const ResumePdf: FC<ResumePdfProps> = (props) => (
  <Document>
    <Page size="A4" style={styles.page}>
      <ResumePdfHeader {...props} />
      {/* Контакты */}
      <ResumePdfContacts {...props} />
      {/* Общая информация */}
      <ResumePdfGeneralInfo {...props} />
      {/* Навыки */}
      <ResumePdfSkills {...props} />
      {/* Опыт работы */}
      <ResumePdfCompanyExperience {...props} />
      {/* Образование */}
      <ResumePdfEducation {...props} />
      {/* Курсы */}
      <ResumePdfCourses {...props} />
      {/* Языки */}
      <ResumePdfLanguages {...props} />
    </Page>
  </Document>
);
